import React from 'react';

import styled, { css } from 'styled-components';

import {
  CollapseHeaderContentWrapper,
  CollapseHeaderLabel,
  ResponsiveSortTabs,
} from '@components/views/components/listing/drawer/ResponsiveListingFilterAndSortStyle';
import palette from '@utils/theme/palette';
import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';
import Accordion from '@components/Accordion/next/Accordion';
import TabsComponent from '@components/Tabs';
import Typography from '@components/Typography';

const NoneCollapsableWrapper = styled.div`
  /* padding: 0 8px; */
`;

const NoneCollapsableContent = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 12px;
  max-width: 100%;
`;
export const ButtonIcon = styled.button`
  border: none;
  background-color: transparent;
`;

const SortTabList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const SortTab = styled.div<{ active: boolean; disabled: boolean }>`
  width: fit-content;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL40};

  ${({ active, theme }) =>
    active
      ? css`
          background-color: ${theme.palette.NL30};
          border-color: ${theme.palette.NL80};
        `
      : css``}
`;
interface ResponsiveListingSortInterface {
  data: Array<{
    id: string | number;
    label: string;
    disabled?: boolean;
  }>;
  activeKey: string;
  select?: string;
  handleTabClick: (
    key: string,

    e: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>
  ) => void;
  collapsable?: boolean;
}
const TourText =
  'Turlar kullanıcı seçimine göre; popüler, artan fiyat, azalan fiyata göre sıralanır. Sıralama; artan veya azalan fiyat seçimi yapıldığında fiyatlara göre, popüler seçimi yapıldığında ise Setur’un değişken tercihlerine göre yapılır.';
const HotelText =
  'Tesisler kullanıcı seçimine göre; popüler, artan fiyat, azalan fiyat, artan indirim, azalan indirime göre sıralanır. Sıralama; artan veya azalan fiyat seçimi yapıldığında fiyatlara göre, artan veya azalan indirim seçimi yapıldığında indirime göre, popüler seçimi yapıldığında ise Setur’un değişken tercihlerine göre yapılır.';

const ResponsiveListingSort = ({
  data,
  handleTabClick,
  select,
  activeKey,
  collapsable = true,
}: ResponsiveListingSortInterface) => {
  return collapsable ? (
    <Accordion
      headerContentColor='eclipse'
      alwaysShowBottomBorder={false}
      headerPadding='15px'
      mobileLabelFontSize='16px'
      iconSize={16}
      iconColor='coral'
      backgroundColor='white'
      labelWeight={400}
      bodyBackgroundColor='grayWhite'
      label={
        <CollapseHeaderContentWrapper>
          {select !== 'flight' ? (
            <Tooltip
              overlayInnerStyle={{
                position: 'relative',
                borderRadius: 10,
                maxWidth: 270,
                backgroundColor: palette.darkGrey,
                fontSize: 14,
                color: palette.white,
                lineHeight: 1.43,
                textAlign: 'left',
                padding: '10px',
              }}
              placement='bottomLeft'
              title={select === 'hotel' ? HotelText : TourText}
            >
              <ButtonIcon
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <CustomIcon
                  icon={InfoIcon}
                  paletteColor='darkGray'
                  data-testid='icon-container'
                  fontSize={24}
                />
              </ButtonIcon>
            </Tooltip>
          ) : null}

          <CollapseHeaderLabel>Sırala</CollapseHeaderLabel>
        </CollapseHeaderContentWrapper>
      }
    >
      <ResponsiveSortTabs>
        <TabsComponent activeKey={activeKey} onTabClick={handleTabClick}>
          {data?.map((tab) => (
            <TabsComponent.TabPane
              disabled={tab.disabled}
              tab={tab.label}
              key={tab.id}
            />
          ))}
        </TabsComponent>
      </ResponsiveSortTabs>
    </Accordion>
  ) : (
    <NoneCollapsableWrapper>
      <CollapseHeaderContentWrapper>
        <CollapseHeaderLabel>Sırala</CollapseHeaderLabel>
        {select !== 'flight' ? (
          <Tooltip
            overlayInnerStyle={{
              position: 'relative',
              borderRadius: 10,
              maxWidth: 270,
              backgroundColor: palette.darkGrey,
              fontSize: 14,
              color: palette.white,
              lineHeight: 1.43,
              textAlign: 'left',
              padding: '10px',
            }}
            placement='bottomLeft'
            title={select === 'hotel' ? HotelText : TourText}
          >
            <ButtonIcon
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <CustomIcon
                icon={InfoIcon}
                paletteColor='darkGray'
                data-testid='icon-container'
                fontSize={20}
              />
            </ButtonIcon>
          </Tooltip>
        ) : null}
      </CollapseHeaderContentWrapper>
      <NoneCollapsableContent>
        <SortTabList>
          {data?.map((tab) => (
            <SortTab
              disabled={tab.disabled || false}
              active={tab.id === activeKey}
              key={tab.id}
              onClick={() => handleTabClick(String(tab.id), {} as any)}
            >
              <Typography
                color='NL800'
                variant='caption2'
                weight={tab.id === activeKey ? 'SemiBold' : 'Regular'}
              >
                {tab.label}
              </Typography>
            </SortTab>
          ))}
        </SortTabList>
      </NoneCollapsableContent>
    </NoneCollapsableWrapper>
  );
};

export default ResponsiveListingSort;
